import React from "react";
import { i18nTranslate } from "@didi/i18n-plugin";
import errorIcon from "@/assets/images/common/error-img.webp";
import errorIconUNO from "@/assets/images/common/network-error-uno.png";
import "./index.less";

type Props = {
  /** 显式指定 Uno 样式；未传入时从当前 URL 判断。 */
  useUNO?: boolean;
  text?: string;
  subText?: string;
  retryText?: string;
  onRetry: () => void;
};

function isUNOEnabled(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("useUNO") === "1") {
    return true;
  }

  const hash = window.location.hash || "";
  const hashQueryStart = hash.indexOf("?");
  if (hashQueryStart < 0) {
    return false;
  }

  const hashParams = new URLSearchParams(hash.substring(hashQueryStart + 1));
  return hashParams.get("useUNO") === "1";
}

/** 展示网络异常兜底，优先采用调用方指定的 Uno 样式。 */
export default function NetworkError({
  useUNO: useUNOOverride,
  text = i18nTranslate("Fintech_Payment_Ahorro_mFQz_mpkb"),
  subText = i18nTranslate("Fintech_Payment_Ahorro_FTbq_RnIh"),
  retryText = i18nTranslate("Fintech_Payment_Ahorro_dGgq_KZal"),
  onRetry,
}: Props): JSX.Element {
  const useUNO = React.useMemo(
    () => useUNOOverride ?? isUNOEnabled(),
    [useUNOOverride],
  );

  React.useEffect(() => {
    if (!useUNO) return undefined;

    const navElement = document.querySelector(".td-immersive-nav");
    const previousBackground =
      navElement instanceof HTMLElement ? navElement.style.backgroundColor : "";

    if (navElement instanceof HTMLElement) {
      navElement.style.backgroundColor = "#f5f5fa";
    }

    window.Fusion?.setNavigationBarStyle?.({
      backgroundColor: "#f5f5fa",
      bgColor: "#f5f5fa",
    });

    try {
      window.Fusion?.loadModule?.("SofiBridgeModule")?.sfSetNavigationBarStyle?.({
        bgColor: "#f5f5fa",
        backStyle: 0,
      });
    } catch (error) {
      void error;
    }

    return () => {
      if (navElement instanceof HTMLElement) {
        navElement.style.backgroundColor = previousBackground;
      }
    };
  }, [useUNO]);

  if (useUNO) {
    return (
      <div className="td-network-error td-network-error--uno">
        <div className="td-network-error__content">
          <div className="td-network-error__icon-frame">
            <img
              className="td-network-error__icon"
              src={errorIconUNO}
              alt="error"
            />
          </div>
          <div className="td-network-error__title">{text}</div>
          <div className="td-network-error__desc">{subText}</div>
        </div>
        <div className="td-network-error__action">
          <button
            type="button"
            className="td-network-error__btn td-network-error__btn--uno"
            onClick={onRetry}
          >
            {retryText}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="td-network-error">
      <img className="td-network-error__icon" src={errorIcon} alt="error" />
      <div className="td-network-error__title">{text}</div>
      <div className="td-network-error__desc">{subText}</div>
      <button type="button" className="td-network-error__btn" onClick={onRetry}>
        {retryText}
      </button>
    </div>
  );
}
